module.exports = __webpack_public_path__ + "img/cert4.13139d08.png";